export const CHANNEL_REGISTRY = {
"2": {
  displayName: "Mr. Rogers Neighborhood",
  logoKey: "mrrogers2",
  category: "Kids / Educational",
},

  "4": {
    displayName: "CBS",
    callsign: "WBZ",
    network: "CBS",
    logoKey: "cbs",
    category: "Broadcast",
  },

  "5": { displayName: "ABC News", logoKey: "abcnews2", category: "News" },
"7": { displayName: "NBC News", logoKey: "nbcnews2", category: "News" },
"8": { displayName: "NBC", logoKey: "nbc2", category: "Broadcast" },
"9": { displayName: "The Joy of Painting", logoKey: "bobross", category: "Arts / Calm" },
"10": { displayName: "FOX", logoKey: "fox2", category: "Broadcast" },
"12": { displayName: "CBS", logoKey: "cbs", category: "Broadcast" },
"13": { displayName: "FOX", logoKey: "fox2", category: "Broadcast" },
"15": { displayName: "CNN", logoKey: "cnn", category: "News" },
"19": { displayName: "A&E", logoKey: "ae2", category: "Broadcast" },
"20": { displayName: "USA", logoKey: "usa", category: "Broadcast" },
"21": { displayName: "TNT", logoKey: "tnt2", category: "Broadcast" },
"22": { displayName: "ESPN", logoKey: "espn", category: "Sports" },
"23": { displayName: "NESN", logoKey: "nesn", category: "Sports" },
"24": { displayName: "NICK JR.", logoKey: "nickjr", category: "Kids" },
"25": { displayName: "NICKELODEON", logoKey: "nickelodeon", category: "Kids" },
"26": { displayName: "SNICK", logoKey: "snick", category: "Kids" },
"27": { displayName: "NICK@NITE", logoKey: "nickatnite", category: "Broadcast" },
"28": { displayName: "MTV", logoKey: "mtv", category: "Broadcast" },
"29": { displayName: "MTV2", logoKey: "mtv2", category: "Broadcast" },
"30": { displayName: "VH1", logoKey: "vh1", category: "Broadcast" },
"42": { displayName: "Hallmark", logoKey: "hallmark", category: "Movies" },
};